__turbopack_context__.v({
  "container": "ExploreResources-module-scss-module__ZWCqza__container",
  "exploreResources": "ExploreResources-module-scss-module__ZWCqza__exploreResources",
});
